
export const shopInfoContainer = {
  companyNameTitle: 'YourCarpet.com',
  companyNameLegal: 'The Magic Carpets Company S.L.',
  baseURL: 'https://www.yourcarpet.com',
  address: {
    street: 'Av Luis Braille 18',
    city: 'Marbella',
    postalCode: '29670',
    country: 'Spain',
  },
  phone: '+34952788075',
  googleMapsPlaceID: 'ChIJK82HUz0qcw0Rs-Nf6tyIna4',
  socialMedia: {
    facebookPageURL: 'https://www.facebook.com/YourCarpetCom',
    pinterestPageURL: 'https://www.pinterest.com/YourCarpetCom',
    linkedinPageURL: 'https://www.linkedin.com/company/yourcarpetcom',
    twitterPageURL: 'https://www.x.com/Yourcarpetcom',
    tiktokPageURL: 'https://www.tiktok.com/@yourcarpet.com',
  }
}


export const daysOfWeek = {
  marbella: [
    { name: 'monday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'tuesday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'wednesday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'thursday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'friday', hours: '10AM - 8PM', startTime: '10:00', endTime: '20:00' },
    { name: 'saturday', hours: '10AM - 3PM', startTime: '10:00', endTime: '15:00' },
    { name: 'sunday', hours: 'Closed', startTime: '', endTime: '' }
  ],
  bilbao: [
    { name: 'monday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'tuesday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'wednesday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'thursday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'friday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'saturday', hours: '10AM - 2:30PM, 4PM - 8:30PM', startTime: '10:00,16:00', endTime: '14:30,20:30' },
    { name: 'sunday', hours: 'Closed', startTime: '', endTime: '' }
  ]
};
